module.exports = __webpack_public_path__ + "static/media/lockWarning.d9c73081.svg";